import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { Alert, Button, LinearProgress, Stack, Typography } from '@mui/material'
import LaunchIcon from '@mui/icons-material/Launch'
import API from '../../../services/API'
import GapSeverityChip from '../components/GapSeverityChip'
import { getFixLink } from './GapsList'

// Personal view of CQC gaps assigned to the signed-in user, reached from the
// home-screen To Do badge. Deliberately NOT Governance-gated: gaps can be
// assigned to anyone (a fleet manager, a trainer), and each row's fix link
// takes them to the area they already have access to.
const MyGaps = () => {
  const [gaps, setGaps] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    API.get('/cqc-centre/my-gaps')
      .then((res) => {
        if (res.status === 200) setGaps(res.data.gaps)
      })
      .catch((e) => console.log(e))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <LinearProgress />

  return (
    <Stack gap={2}>
      <Typography variant="title1">My CQC Gaps</Typography>
      <Typography variant="body2" color="text.secondary">
        Compliance gaps assigned to you. Each one resolves automatically once the underlying
        issue is fixed - use the link to go straight to where that happens.
      </Typography>

      {gaps.length === 0 && (
        <Alert severity="success">Nothing assigned to you right now - all clear.</Alert>
      )}

      <Stack gap={1}>
        {gaps.map((gap) => {
          const fixLink = getFixLink(gap)
          return (
            <Stack
              key={gap._id}
              direction={{ xs: 'column', sm: 'row' }}
              gap={1}
              alignItems={{ sm: 'center' }}
              justifyContent="space-between"
              sx={{ p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
            >
              <Stack direction="row" gap={1} alignItems="center">
                <GapSeverityChip severity={gap.severity} />
                <Stack>
                  <Typography variant="body2">{gap.message}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {gap.keyQuestion} - assigned{' '}
                    {gap.assignedAt ? moment(gap.assignedAt).fromNow() : 'to you'}
                  </Typography>
                </Stack>
              </Stack>
              {fixLink && (
                <Button
                  size="small"
                  variant="contained"
                  endIcon={<LaunchIcon />}
                  onClick={() => navigate(fixLink.path)}
                  sx={{ flexShrink: 0 }}
                >
                  {fixLink.label}
                </Button>
              )}
            </Stack>
          )
        })}
      </Stack>
    </Stack>
  )
}

export default MyGaps
